module.exports = __webpack_public_path__ + "static/media/peughouia2.8b9c4178.jpg";